// Plăcuță de înmatriculare stil RO — detaliu de brand real (VLY = Valy)
export const LicensePlate = ({ className = "" }) => (
  <div
    data-testid="license-plate"
    className={`inline-flex items-stretch rounded-[6px] overflow-hidden ring-2 ring-slate-900/70 bg-white shadow-lg select-none ${className}`}
  >
    <div className="bg-[#003399] flex flex-col items-center justify-center px-1.5 py-1 gap-0.5">
      <svg viewBox="0 0 24 24" className="w-3.5 h-3.5">
        {[...Array(12)].map((_, i) => {
          const a = (i * 30 * Math.PI) / 180;
          return <circle key={i} cx={12 + 7.5 * Math.cos(a)} cy={12 + 7.5 * Math.sin(a)} r={1} fill="#ffffff" />;
        })}
      </svg>
      <span className="text-[8px] font-bold text-white leading-none">RO</span>
    </div>
    <div className="px-3 flex items-center bg-white">
      <span className="font-display font-extrabold text-slate-900 text-lg sm:text-xl tracking-[0.18em]">IS&nbsp;76&nbsp;VLY</span>
    </div>
  </div>
);

export default LicensePlate;
